import { useAtomValue } from 'jotai'
import React from 'react'

import {
  buildNineSegmentsTotalData,
  type NineSegmentsTotalData,
} from '~/apps/ninesegsAnalyzer/utils/standardAnalysis'
import { useSampleSize } from '~/hooks/useSampleSize'
import { type Brand } from '~/hooks/useSurveyQuery'

import { tabulationQueryDataAtom } from '../atoms'

import { useGetBrandNineSegmentIndex } from './useGetBrandNineSegmentIndex'

export const useNineSegmentsTotalData = (
  brand: Brand,
): NineSegmentsTotalData => {
  const sampleSize = useSampleSize()
  const tabulationQueryData = useAtomValue(tabulationQueryDataAtom)
  const getBrandNineSegmentIndex = useGetBrandNineSegmentIndex()

  return React.useMemo(
    () =>
      buildNineSegmentsTotalData({
        brand,
        getBrandNineSegmentIndex,
        groupCounts: tabulationQueryData?.question?.groupCounts ?? [],
        sampleSize,
      }),
    [
      brand,
      getBrandNineSegmentIndex,
      sampleSize,
      tabulationQueryData?.question?.groupCounts,
    ],
  )
}
